<template>
  <default-layout>
    <v-runtime-template :template="header_content"></v-runtime-template>
    <event-navbar title="Sponsoren" />
    <div class="container-fluid">
      <sponsor-list :event-short-name="$route.params.shortName"></sponsor-list>
    </div>
    <v-runtime-template :template="footer_content"></v-runtime-template>
  </default-layout>
</template>

<script>
// @ is an alias to /src
import ListViewStorageMixin from './ListViewStorageMixin.js'
import VRuntimeTemplate from "v-runtime-template";
import SponsorList from '@/components/exhibitor/sponsor-list.vue'
import EventNavbar from '@/components/EventNavbar.vue'
import DefaultLayout from '@/components/DefaultLayout.vue'

export default {
  name: 'SponsorListView',
  mixins: [ListViewStorageMixin],
  components: {
    SponsorList, EventNavbar, VRuntimeTemplate, DefaultLayout
  },
  created() {
    this.fetchBannerContent('sponsors')
  },
}
</script>
